import React, { useState } from "react";
import './recetario.css'

export default function ListaRecetarioForm() {
  // Productos que son grupos (con variantes relacionadas)
  const [fechaActual] = useState(new Date().toISOString().split('T')[0])
  const [formData, setFormData] = useState({});

  const [gruposState, setGruposState] = useState( {
    pasteles: {
      id: 2,
      nombre: "PASTELES",
      tipo: "grupo",
      principal: { key: "kilospaste", label: "KILOS" },
      secundario: {key:"pastel", label:"PASTEL"},
      calcularTotal: (variantes) => variantes.reduce((total, variante) => total + (variante.cantidad || 0),0),
      variantes: [
        {id: 1, cantidad:0, key: "pastelJamonQueso", label: "PASTEL DE JAMÓN Y QUESO" },
        {id: 2, cantidad:0, key: "pastelCarne", label: "P. DE CARNE" },
        {id: 3, cantidad:0, key: "pastelPollo", label: "P. DE POLLO" },
        {id: 4, cantidad:0, key: "milhojas", label: "MILHOJAS" },
        {id: 5, cantidad:0, key: "cachitos", label: "CACHITOS" },
        {id: 6, cantidad:0, key: "pastelCarneBocadito", label: "P. DE CARNE BOCADITO" },
        {id: 7, cantidad:0, key: "pastelPolloBocadito", label: "P. DE POLLO BOCADITO" },
        {id: 8, cantidad:0, key: "milhojasBocadito", label: "MILHOJAS BOCADITO" },
        {id: 9, cantidad:0, key: "cachitosBocadito", label: "CACHITOS BOCADITO" }
      ]
    },
    biscochuelos: {
      id: 3,
      nombre: "BISCOCHUELOS",
      tipo: "grupo",
      principal: { key: "tanda", label: "TANDA" },
      secundario:{key:"biscochuelos", label:"BISCOCHUELO"},
      variantes: [
        { id: 1, cantidad:0, key: "rectangular", label: "B. RECTANGULAR" },
        { id: 2, cantidad:0, key: "redondagrande", label: "B. REDONDA GRANDE" },
        { id: 3, cantidad:0, key: "redondamediana", label: "B. REDONDA MEDIANA" },
        { id: 4, cantidad:0, key: "redondachica", label: "B. REDONDA PEQUEÑO" },
        { id: 5, cantidad:0, key: "corazongrande", label: "B. CORAZON GRANDE" },
        { id: 6, cantidad:0, key: "corazonmediano", label: "B. CORAZON MEDIANO" },
        { id: 7, cantidad:0, key: "corazonpequeño", label: "B. CORAZON PEQUEÑO" },
        { id: 8, cantidad:0, key: "minibicochuelo", label: "MINI - BOSCOCHUELO" },
      ],calcularTotal: (variantes) => {
        let total = 0;
        variantes.forEach(v => {
          switch(v.id) {
            case 3: case 6: total += v.cantidad / 2; break; // 2 unidades = 1 biscochuelo && 6 biscochuelo = 1 tanda
            case 4: case 7: total += v.cantidad / 4; break; // 4 unidades = 1 biscochuelo && 6 biscochuelo = 1 tanda
            case 8: total += v.cantidad / 8; break;         // 8 unidades = 1 biscochuelo && 6 biscochuelo = 1 tanda
            default: total += v.cantidad; break;            // 1 unidad = 1 total
          }
        });
        return total;
      }
    },
    queque: {
      id: 4,
      nombre: "QUEQUE",
      tipo: "grupo",
      principal: { key: "tandaqueque", label: "TANDA" },
      secundario:{key:"queque", label:"QUEQUE"},
      observaciones:"",
      calcularTotal:(variante) => variante.reduce((total, variante) => total + (variante.cantidad || 0),0),
      variantes: [
        {id: 1, cantidad:0, key: "chispas", label: "QUEQUES CHISPAS" },
        {id: 2, cantidad:0, key: "pasas", label: "QUEQUES PASAS" },
        {id: 3, cantidad:0, key: "cupcake", label: "CUPCAKE CHISPAS" },
      ]
    },
  });

  // Productos individuales (cada uno es independiente)
  const productosIndividuales = {
    hojarascasLata: {
      id: 1,
      nombre: "HOJARASCAS (LATA)",
      key: "latasHojarascas",
      label: "LATAS DE HOJARASCAS"
    },
    hojarascasBocadito: {
      id: 2,
      nombre: "HOJARASCAS BOCADITO (LATA)",
      key: "latasHojarascasBocadito",
      label: "LATAS DE HOJARASCAS DE BOCADITO"
    },
    cremaMantequilla: {
      id: 3,
      nombre: "CREMA DE MANTEQUILLA",
      key: "tandaCremaManteq",
      label: "TANDA DE CREMA DE MANTEQUILLA"
    },
    librasPan: {
      id: 4,
      nombre: "LIBRAS DE PAN",
      key: "libradepan",
      label: "LIBRAS DE PAN"
    },
    Bocadito: {
      id: 5,
      nombre: "BOCADITO",
      key: "bocadito",
      label: "BOCADITO"
    },
    empanadaCarne: {
      id: 6,
      nombre: "EMPANADA DE CARNE",
      key: "empanadaCarne",
      label: "EMPANADA DE CARNE"
    },
    empanadaCarneBocadito: {
      id: 7,
      nombre: "EMPANADA DE CARNE BOCADITO",
      key: "empanadaCarneBocadito",
      label: "EMPANADA DE CARNE BOCADITO"
    },
    empanadaPollo: {
      id: 8,
      nombre: "EMPANADA DE POLLO",
      key: "empanadaPollo",
      label: "EMPANADA DE POLLO"
    },
    empanadaPolloBocadito: {
      id: 9,
      nombre: "EMPANADA DE POLLO BOCADITO",
      key: "empanadaPolloBocadito",
      label: "EMPANADA DE POLLO BOCADITO"
    },
    canastillas: {
      id: 10,
      nombre: "CANASTILLAS",
      key: "canastillas",
      label: "CANASTILLAS"
    },
    pionono: {
      id: 11,
      nombre: "PIONONO",
      key: "pionono",
      label: "PIONONO"
    },
    quintalesRoscas: {
      id: 12,
      nombre: "QUINTALES DE ROSCAS",
      key: "quintalesRoscas",
      label: "QUINTALES DE ROSCAS"
    },
    degustacionRoscas: {
      id: 13,
      nombre: "LATA DE DEGUSTACION DE ROSCAS",
      key: "degustacionRoscas",
      label: "LATA DE DEGUSTACION DE ROSCAS"
    },
    galletasLeche: {
      id: 14,
      nombre: "QUINTALES GALLETAS DE LECHE",
      key: "degustacionRoscas",
      label: "QUINTALES GALLETAS DE LECHE"
    },
    degustacionLeche: {
      id: 15,
      nombre: "LATA DE DEGUSTACION GALLETA",
      key: "degustacionGalleta",
      label: "LATA DE DEGUSTACION GALLETA"
    },
    panMaiz: {
      id: 16,
      nombre: "QUINTALES DE PAN DE MAIZ",
      key: "panMaiz",
      label: "QUINTALES DE PAN DE MAIZ"
    },
    degustacionPanMaiz: {
      id: 17,
      nombre: "LATA DE DEGUSTACIONA PAN DE MAIZ",
      key: "degustacionMaiz",
      label: "LATA DE DEGUSTACIONA PAN DE MAIZ"
    },
  };

  const handleChange = (e, grupoKey, varianteKey) => {
    const { value } = e.target;
    const numValue = parseInt(value) || 0;

    setGruposState(prev => {
      // 1. Actualizar la variante específica
      const grupoActualizado = {
        ...prev[grupoKey],
        variantes: prev[grupoKey].variantes.map(v => 
          v.key === varianteKey ? {...v, cantidad: numValue} : v
        )
      };

      // 2. Calcular el nuevo total usando la función específica del grupo
      const nuevoTotal = grupoActualizado.calcularTotal(grupoActualizado.variantes);

      let totalTanda;
      if (grupoKey === 'biscochuelos') {
        totalTanda = Math.floor(nuevoTotal / 6);
      } else if (grupoKey === 'queque') {
        totalTanda = Math.floor(nuevoTotal / 94);
      } else if (grupoKey === 'pasteles'){
        totalTanda = Math.floor(nuevoTotal / 60);
      }else {
        totalTanda = nuevoTotal;
      }

      // 3. Actualizar formData con los nuevos valores
      setFormData(prevFormData => ({
        ...prevFormData,
        [varianteKey]: numValue,
        [grupoActualizado.secundario.key]: nuevoTotal ,
        [grupoActualizado.principal.key]: totalTanda,
        ...(grupoKey === 'queque' && {
          observaciones_queque: prev[grupoKey].observaciones
        })
      }));

      // 4. Retornar el estado actualizado de los grupos
      return {
        ...prev,
        [grupoKey]: grupoActualizado
      };
    });
  };
  const handleObservacionesChange = (e,grupoKey) => {
    const {value} = e.target;

    setGruposState(prev => ({
      ...prev,
      [grupoKey] : {
        ...prev[grupoKey],
        observaciones: value
      }
    }));

    setFormData(prev => ({
      ...prev,
      [`observaciones_${grupoKey}`]: value
    }))
  }
  const handleChangeIndividual = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: parseInt(value) || 0
    }));
  };


  return (
    <div className="order-form-container">
      <div>
        <div className="form-actions">
          <button type="button" className="btn-verde-mfp">Emitir Pedido</button>
          <button type="button" className="btn-anular ml-1">Cancelar</button>
        </div>
      </div>
      
      <div className="bakery-order-form">
        <div className="abed_content-fecha">
          <label>Registro:</label> <input type="date" className="abed__input-fecha" value={fechaActual} readOnly />
        </div>
        {/* Renderizar grupos */}
        {Object.entries(gruposState).map(([grupoKey, grupo]) => (
          <div key={grupo.id} className="order-section grupo-section">
            <div className="grupo-container">
              <div className="grupo-principal">
                <div className="input-group principal-input">
                  <label>{grupo.secundario.label}</label>
                  <input 
                    type="number" 
                    name={grupo.secundario.key}
                    value={formData[grupo.secundario.key] || ''}
                    className="abed__input-numero"
                    placeholder="Total"
                    readOnly
                  />
                  <label>{grupo.principal.label}</label>
                  <input 
                    type="number" 
                    name={grupo.principal.key}
                    value={formData[grupo.principal.key] || ''}
                    className="abed__input-numero"
                    placeholder="Total"
                    readOnly
                  />
                </div>
              </div>

              {/* Variantes del grupo */}
              <div className="grupo-variantes">
                {grupo.variantes.map((variante) => (
                  <div key={`${grupoKey}-${variante.key}`} className="abed__input-group variante-item">
                    <input
                      type="number"
                      name={variante.key}
                      value={formData[variante.key] || 0}
                      onChange={(e) => handleChange(e, grupoKey, variante.key)}
                      className="abed__input-numero"
                    />
                    <label className="abed__label-numero">{variante.label}</label>
                  </div>
                ))}
              </div>
              {grupoKey === 'queque' && (
                <div className="observaciones-container">
                  <label>Observaciones:</label>
                  <input
                    type="text"
                    value={grupo.observaciones || ''}
                    onChange={(e) => handleObservacionesChange(e, grupoKey)}
                    className="abed__input-text"
                    placeholder="Notas adicionales para los queques"
                  />
                </div>
              )}
            </div>
          </div>
        ))}

        {/* Renderizar productos individuales */}
        <div className="order-section productos-individuales-section">
          <h3 className="individuales-title">OTROS PRODUCTOS</h3>
          
          <div className="productos-individuales-container">
            {Object.values(productosIndividuales).map((producto) => (
              <div key={producto.id} className="abed__input-group producto-individual">
                <label>{producto?.label || ''}</label>
                <input
                  type="number"
                  name={producto.key}
                  value={formData[producto.key] || ''}
                  onChange={handleChangeIndividual}
                  className="abed__input-numero"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
